let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lWYcK")).then(() => parcelRequire('58Da3'));